require('../../modules/es.array.of');

module.exports = require('../../internals/path').Array.of;
